'use strict';

var _ = require('lodash');
var FOMarketsService = function FOMarketsService(restangular, App) {
  function loadFoMarkets() {
    App.poses = App.poses || [];
    App.markets = App.markets || [];
    App.marketsGenerateNewCancel = App.marketsGenerateNewCancel || [];
    return getFoMarkets().then(function (response) {
      var foMarkets = response.markets;
      App.markets = processFoMarkets(foMarkets);
      App.marketsGenerateNewCancel = processMarketsGenerateNewCancelFlag(foMarkets);
      App.poses = processFoPoses(foMarkets);
      App.marketTiers = processFoMarketTiers(foMarkets);
      App.foBenchmarkCarriers = processFoBenchmarkCarriers(foMarkets);
      App.foBenchmarkCarrierToMarketMap = populateBenchmarkCarrierToMarketMap();
      App.foMarketGroupType = processFoMarketGroup(foMarkets);
    });
  }
  function processFoMarkets(foMarkets) {
    var uniqueFoMarkets = _.chain(foMarkets).map(function (item) {
      return _.pick(item, ['origin', 'destination']);
    }).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
    var uniqueFoMarketsCache = _.cloneDeep(uniqueFoMarkets);
    var foMarketsToBeDeleted = [];
    _.forEach(App.markets, function (appMarket) {
      var foMarket = _.find(uniqueFoMarkets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      });
      if (!_.isNil(foMarket)) {
        _.merge(appMarket, foMarket);
        _.remove(uniqueFoMarkets, foMarket);
      }
      if (_.isNil(foMarket) && !_.isNil(_.find(App.foMarkets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      }))) {
        foMarketsToBeDeleted.push(appMarket);
      }
    });
    _.forEach(foMarketsToBeDeleted, function (appMarket) {
      var foMarket = _.find(App.markets, {
        origin: appMarket.origin,
        destination: appMarket.destination
      });
      var marketsCopy = App.markets.slice();
      _.remove(marketsCopy, foMarket);
      App.markets = marketsCopy;
    });
    App.foMarkets = uniqueFoMarketsCache;
    return _.chain(App.markets).concat(uniqueFoMarkets).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
  }
  function processMarketsGenerateNewCancelFlag(foMarkets) {
    var uniqueFoMarkets = _.chain(foMarkets).map(function (item) {
      return _.pick(item, ['hostCarrier', 'origin', 'destination', 'cabinCode', 'category', 'generateNewCancel']);
    }).uniqBy(function (item) {
      return item.hostCarrier + item.origin + item.destination + item.cabinCode + item.category + item.generateNewCancel;
    }).value();
    var uniqueFoMarketsCache = _.cloneDeep(uniqueFoMarkets);
    var foMarketsToBeDeleted = [];
    _.forEach(App.marketsGenerateNewCancel, function (appMarket) {
      var foMarket = _.find(uniqueFoMarkets, {
        hostCarrier: appMarket.hostCarrier,
        origin: appMarket.origin,
        destination: appMarket.destination,
        cabinCode: appMarket.cabinCode,
        category: appMarket.category,
        generateNewCancel: appMarket.generateNewCancel
      });
      if (!_.isNil(foMarket)) {
        _.merge(appMarket, foMarket);
        _.remove(uniqueFoMarkets, foMarket);
      }
      if (_.isNil(foMarket) && !_.isNil(_.find(App.marketsGenerateNewCancel, {
        hostCarrier: appMarket.hostCarrier,
        origin: appMarket.origin,
        destination: appMarket.destination,
        cabinCode: appMarket.cabinCode,
        category: appMarket.category,
        generateNewCancel: appMarket.generateNewCancel
      }))) {
        foMarketsToBeDeleted.push(appMarket);
      }
    });
    _.forEach(foMarketsToBeDeleted, function (appMarket) {
      var foMarket = _.find(App.marketsGenerateNewCancel, {
        hostCarrier: appMarket.hostCarrier,
        origin: appMarket.origin,
        destination: appMarket.destination,
        cabinCode: appMarket.cabinCode,
        category: appMarket.category,
        generateNewCancel: appMarket.generateNewCancel
      });
      var marketsCopy = App.marketsGenerateNewCancel.slice();
      _.remove(marketsCopy, foMarket);
      App.marketsGenerateNewCancel = marketsCopy;
    });
    App.marketsGenerateNewCancel = uniqueFoMarketsCache;
    return _.chain(App.marketsGenerateNewCancel).concat(uniqueFoMarkets).uniqBy(function (item) {
      return item.hostCarrier + item.origin + item.destination + item.cabinCode + item.category + item.generateNewCancel;
    }).value();
  }
  function processFoPoses(foMarkets) {
    var uniqueFoPoses = _.chain(foMarkets).map(function (item) {
      return {
        origin: item.origin,
        destination: item.destination,
        spos: item.pos
      };
    }).value();
    _.forEach(App.poses, function (appPos) {
      var foPos = _.find(uniqueFoPoses, {
        origin: appPos.origin,
        destination: appPos.destination,
        spos: appPos.spos
      });
      if (!_.isNil(foPos)) {
        _.merge(appPos, foPos);
        _.remove(uniqueFoPoses, foPos);
      }
    });
    return _.chain(App.poses).concat(uniqueFoPoses).uniqBy(function (item) {
      return item.origin + item.destination + item.spos;
    }).value();
  }
  function processFoMarketTiers(foMarkets) {
    return _.chain(foMarkets).map(function (item) {
      return {
        marketTier: item.marketTier
      };
    }).value();
  }
  function processFoBenchmarkCarriers(foMarkets) {
    return _.chain(foMarkets).map(function (item) {
      return {
        origin: item.origin,
        destination: item.destination,
        cabin: item.cabinCode,
        category: item.category,
        benchmarkCarriers: getBenchmarkCarriers(item.benchmarkDetails)
      };
    }).value();
  }
  function getBenchmarkCarriers(benchmarkDetails) {
    return _.chain(benchmarkDetails).map('benchmarkCarrier').flatten().value();
  }
  function processFoMarketGroup(foMarkets) {
    return _.chain(foMarkets).map(function (item) {
      return {
        origin: item.origin,
        destination: item.destination,
        marketGroup: item.marketGroup,
        marketType: item.marketType,
        marketAnalyst: item.marketAnalyst,
        marketCategory: item.marketCategory
      };
    }).value();
  }
  function populateBenchmarkCarrierToMarketMap() {
    var carrierToMarketMap = {};
    _.forEach(App.foBenchmarkCarriers, function (foMarket) {
      _.forEach(foMarket.benchmarkCarriers, function (airline) {
        if (!carrierToMarketMap[airline]) {
          carrierToMarketMap[airline] = [];
        }
        var market = foMarket.origin + '-' + foMarket.destination;
        if (!_.includes(carrierToMarketMap[airline], market)) {
          carrierToMarketMap[airline].push(market);
        }
      });
    });
    return carrierToMarketMap;
  }
  function getFoMarkets() {
    return restangular.one('external').one('faresoptimizer').one('fomarkets').get({
      pageLimit: -1
    });
  }
  return {
    loadFoMarkets: loadFoMarkets
  };
};
FOMarketsService.$inject = ['Restangular', 'App'];
module.exports = FOMarketsService;